export default __webpack_public_path__ + "2abc5c5a20adafddbf6914feb7072021.png";